<mat-card appearance="outlined" class="correction-step-card">
    <div class="left-section">
        <mat-icon class="action-icon">{{ stepIcon }}</mat-icon>
        <span class="field-type-badge">{{ fieldTypeLabel }}</span>
    </div>
    <div class="middle-section">
        <p class="text-step">{{ stepText }}</p>
    </div>
    <div class="right-section">
        <button
            mat-icon-button
            class="delete-button"
            (click)="removeStep()"
            title="Remove this step"
        >
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</mat-card>
